import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import { assetContentsResponseDefaults } from '../../details/records/AssetContentsResponse';
import ModuleContentItem from './ModuleContentItem';
const moduleContentsResponseDefaults = Object.assign({}, assetContentsResponseDefaults, {
  contents: {
    contents: []
  }
});
export default class ModuleContentsResponse extends createImmutableObjectClass(moduleContentsResponseDefaults, {
  fromJSON: (_ref) => {
    let {
      contents
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["contents"]);

    return cleanObject(Object.assign({
      contents: contents.contents.map(content => new ModuleContentItem(content))
    }, rest));
  },
  toJSON: (_ref2) => {
    let {
      contents
    } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, ["contents"]);

    return Object.assign({
      contents: {
        contents: contents.map(content => content.toJSON())
      }
    }, rest);
  }
}) {}